function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M19.935 2.64981C20.3254 2.25934 20.9595 2.25944 21.35 2.64981C21.7403 3.04028 21.7403 3.6734 21.35 4.06388L13.4135 11.9994 21.35 19.935C21.7405 20.3255 21.7405 20.9595 21.35 21.35C20.9595 21.7405 20.3255 21.7405 19.935 21.35L11.9994 13.4135 4.06388 21.35C3.6734 21.7403 3.04028 21.7403 2.64981 21.35C2.25944 20.9595 2.25934 20.3254 2.64981 19.935L10.5844 11.9994 2.64981 4.06388C2.25944 3.67334 2.25934 3.04029 2.64981 2.64981C3.04029 2.25934 3.67334 2.25944 4.06388 2.64981L11.9994 10.5844 19.935 2.64981Z"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.04da6755.svg";
export { ForwardRef as ReactComponent };